import { Controller, useFormContext } from 'react-hook-form'

import TextArea from 'modules/core/components/TextArea'
import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'description'

const DescriptionField = ({
  isFieldMandatory,
  isFieldReadOnly,
}: WithCustomizationFieldsProps & WithFieldPermissionsProps) => {
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext()

  // NOTE: This component is intentionally subscribed to its own value using watch().
  // The underlying input component from the deprecated design system does not reliably
  // re-render when its `value` prop changes, causing a "stale UI" bug.
  //
  // Calling watch() creates a subscription that forces this wrapper component to
  // re-render on every change, ensuring the UI stays in sync with the form state.
  // This is a targeted workaround for the external library's rendering issue.
  watch(FIELD_NAME)

  return (
    <Controller
      control={control}
      name={FIELD_NAME}
      render={({ field }) => (
        <TextArea
          label={i18n.t('expenses_v2.forms.fields.description.label')}
          mandatory={isFieldMandatory}
          value={field.value}
          onChange={(value) => field.onChange(value)}
          placeholder={i18n.t('expenses_v2.forms.fields.description.placeholder')}
          error={castError(errors?.description)}
          readonly={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(DescriptionField, FIELD_NAME))
